import { tracking as externalTracking } from "@bark/bark-core";

/**
 * Initialise credit card tracking
 */
export function CreditCardTracking() {

    const externalTrackingEventName = 'credit card modal';

    /**
     * Log an action
     * @param {object} overrideData
     */
    const log = (overrideData) => {
        const data = Object.assign({
            action: 'click',
            pageName: document.location.pathname,
        }, overrideData);

        externalTracking(externalTrackingEventName, data.actionValue, data);
    };

    /**
     * Log generic action
     */
    const logAction = (actionValue, data = {}) => {
        if (!data) {
            data = {};
        }
        data['actionValue'] = actionValue;
        log(data);
    }

    /**
     * Log cancel click
     */
    const logCancelClick = () => {
        logAction('cancel');
    };

    /**
     * Log submit click
     */
    const logSubmit = () => {
        logAction('submit');
    };

    /**
     * Log submit click
     */
    const logClose = () => {
        logAction('close');
    };

    /**
     * Log that a field has received focus
     * @param {string} fieldName
     */
    const logFocus = fieldName => {
        log({
            action: 'focus',
            actionValue: fieldName
        });
    }

    return {
        logAction,
        logCancelClick,
        logClose,
        logFocus,
        logSubmit,
    };
}
